import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/session'

const initialState = null

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  switch (action.type) {
    case actionTypes.SET_SESSION:
      return R.mergeRight(prevState, action.session)
    case actionTypes.CLEAR_SESSION:
      return initialState
    default:
      return prevState
  }
}
